import React from "react";
import { func } from "prop-types";

const NavigationFiltersToggle = ({ onClick }) => (
    <div className="NavigationFiltersToggle">
        <a className="btn filter-btn" onClick={onClick}>
            <i className="fas fa-filter" />
        </a>
    </div>
);

NavigationFiltersToggle.propTypes = {
    onClick: func
};

export default NavigationFiltersToggle;
